import { render, staticRenderFns } from "./pathselect.vue?vue&type=template&id=23011476&scoped=true&"
import script from "./pathselect.vue?vue&type=script&lang=js&"
export * from "./pathselect.vue?vue&type=script&lang=js&"
import style0 from "./pathselect.vue?vue&type=style&index=0&id=23011476&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23011476",
  null
  
)

export default component.exports